export default __webpack_public_path__ + "static/feature_03-08f83796d4cce4dddc61f7bf6713c64f.png";